import { WTrack } from '../WTrack/WTrack.js';
import { player } from '../../utils/player.js';
import { eventEmitter } from '../../utils/eventEmitter/index.js';
const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(`
  :host {
    --host-padding: 20px;
  
    display: none;
    flex-direction: column;
    gap: 10px;
    position: absolute;
    width: 100dvw;
    height: 100dvh;
    top: 0;
    left: 0;
    bottom: 0;
    transform: translateY(100%);
    transition: transform 100ms;
    /*background-color: white;*/
    background-color: var(--color-block);
    padding: var(--host-padding);
    color: white;
    z-index: 40000;
    /*animation-name: Appear;*/
    /*animation-duration: 500ms;*/
    /*animation-fill-mode: forwards;*/
    /*animation-direction: reverse;        */
  }
  
  :host(.opened) {
    display: flex;
    transform: translateY(0);
    /*animation-name: Appear;*/
    /*animation-duration: 500ms;*/
    /*animation-fill-mode: forwards;*/
    /*animation-direction: normal;  */
  }
  
  .items {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  
  .close {
    align-self: flex-end;
  }
  
  @keyframes Appear {
    0% {
        transform: translateY(100%):
    }
    
    100% {
        transform: translateY(0);
    }
  }
`);
export class WPlayerQueueList extends HTMLElement {
    static tag = 'w-player-queue-list';
    constructor() {
        super();
        this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [styleSheet];
    }
    close() {
        this.classList.remove('opened');
    }
    connectedCallback() {
        this.shadowRoot.innerHTML = `
      <r-close-button class="close"></r-close-button>
      <div class="items"></div>
    `;
        this.#processPlayerPlaylist();
        this.#processCloseButtonEvents();
    }
    get isOpened() {
        return this.classList.contains('opened');
    }
    open() {
        this.classList.add('opened');
    }
    #processCloseButtonEvents() {
        this.shadowRoot.querySelector('r-close-button').addEventListener('click', this.close.bind(this));
    }
    #processPlayerPlaylist() {
        this.#renderPlaylist(player.playlist);
        eventEmitter.on('playlist change', ({ playlist }) => {
            this.#renderPlaylist(playlist);
        });
    }
    /** @param {Playlist} playlist  */
    #renderPlaylist(playlist) {
        this.shadowRoot.querySelector('.items').innerHTML = '';
        playlist.items.forEach(i => this.#renderPlaylistItem(i, playlist));
    }
    /**
     * @param {Track} track
     * @param {Playlist | undefined} playlist
     * */
    #renderPlaylistItem(track, playlist) {
        const $track = new WTrack({ track, playlist });
        this.shadowRoot.querySelector('.items').append($track);
    }
}
customElements.define(WPlayerQueueList.tag, WPlayerQueueList);
